export default __webpack_public_path__ + "static/media/product_NPC_banner_Hk.9b9766b0.webp";